import GotQuestions from "./GotQuestionsAboutNeighbourhood";

export default GotQuestions;
